import { render } from "./passwordless-otp-login.vue?vue&type=template&id=159269a0"
import script from "./passwordless-otp-login.vue?vue&type=script&lang=js"
export * from "./passwordless-otp-login.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__